import store from '../store'
import ROUTER from '../router.js'
import { URLS } from '../utils'

import { types as ToastTypes } from '../store/modules/toast'
import { types as LoadingTypes } from '../store/modules/loading'

import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 10000

axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.login.token
    // fe0ff8c7796b2314104d9fd6de7274af4b53b586  f5d99e3acf2b3e76d63d4a8a8a2389d86e43d9cc
    // const token = 'f5d99e3acf2b3e76d63d4a8a8a2389d86e43d9cc'
    if(store.state.login.status){
      // 已登录的话，
      config.headers.common['Authorization'] = 'Token ' + store.state.login.token
    }
    // if (![URLS.loginCommon, URLS.logout].includes(config.url) && token) {
    //   config.headers.common['Authorization'] = 'Token ' + token
    // }
    return config
  },
  error => {
    return Promise.error(error)
  }
)
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    // console.log(response);
    return Promise.resolve(response.data)
  },
  error => {
    var message = ''
    console.log(error)
    if (error.response.status == 401) {
      message = '请重新登录'
      let origin = location.origin
      let newUrl = location.href
      let path
      if (location.host.indexOf('develop.cxy61.com') > -1) {
        origin = 'http://develop.cxy61.com:8004'
      }
      newUrl = encodeURIComponent(newUrl)
      if (location.search) {
        path = `/index/Login?ret=${newUrl}&from=community`
      } else {
        path = `/index/Login?ret=${newUrl}?from=community`
      }
      path = `/index/Login?ret=${newUrl}`
      console.log(path)
      location.href = path
      // ROUTER.push()
      return
    } else if (error.response.status == 400 || error.response.status == 403 || error.response.status == 404) {
      message = error.response.data.detail || error.response.data.message || '未找到'
    } else if (error.response.status == 0) {
      message = '网络未连接，请检查网络后重试。'
    } else if (error.response.status >= 500) {
      message = '服务器出错'
    }

    if (error.response.config.url === URLS.day_play_time) {
      error.response.data["code"] = error.response.status
      return Promise.resolve(error.response.data)
    }

    store.commit(LoadingTypes.HIDE)
    store.commit(ToastTypes.SHOW, { message: message })
    return Promise.reject(error)
  }
)

const GET = (url,params) => {
  return axios.get(url,{params})
}
const POST = (url, data) => {
  return axios.post(url,JSON.stringify( data))
}
const DELETE = url => {
  return axios.delete(url)
}
const PUT = (url, data) => {
  return axios.put(url, data)
}
const PATCH = (url, data) => {
  return axios.patch(url, data)
}

export { GET, POST, DELETE, PUT, PATCH }
